import { getPluralizedCaseCode } from "src/utils/trip-utils";

export function getTourText(getStringRes, key) {
  return getStringRes(key);
}

export function getDaysText(days, getStringRes) {
  if (!Number.isFinite(days)) return "";
  const word = getStringRes(`hotel.result.dates.days_${getPluralizedCaseCode(days)}`);
  return `${days} ${word}`;
}

// "ZIEMEĻPOLIJAS VILINĀJUMS: Vilku midzenis, Sv.Lipka klosteris, ..." ->
// bold title before the colon, the landmark list after it as a separate subtitle line.
export function splitTourName(name) {
  const colonIndex = name.indexOf(":");
  if (colonIndex === -1) return { title: name, subtitle: null };
  return {
    title: name.slice(0, colonIndex),
    subtitle: name.slice(colonIndex + 1).trim(),
  };
}
